import { SupportedFoundations } from "../types/schema";
import { getImageURL } from "../utils/getImageURL";
import { LinkTo } from "./linkTo";

function getContainerClass(index: number): string {
  let baseClass = "grid grid-cols-1 md:gap-3  border-[#e5e5e5] py-6 ";

  if (index === 0) {
    return "border-y border-y-[1px] " + baseClass;
  } else return "border-b border-b-[1px] " + baseClass;
}

export function Organizations(props: { orgs: Array<SupportedFoundations> }) {
  return (
    <>
      <div>
        {props.orgs.map((org, index) => (
          <div key={org._id} className={getContainerClass(index)}>
            <div className="items-center justify-center pt-0 md:block md:pt-4">
              {org.image && (
                <img
                  src={getImageURL(org.image).url()}
                  alt={org.name}
                  className="mb-8 max-h-[90px] max-w-[250px]"
                />
              )}
            </div>
            <div className="py-5 text-body-17 md:py-0">{org.description}</div>
            <div className="text-body-17">
              {org.website && (
                <LinkTo.External
                  url={`https://www.${org.website!}`}
                  className="text-teal"
                >
                  <strong>{org.website}</strong>
                </LinkTo.External>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default Organizations;
